import { memo, SVGAttributes } from 'react';

// Search and profile in the language of the home / calendar / chat icons (24 grid, 1.5 stroke, round caps),
// each with a solid variant for the active tab.
type Props = SVGAttributes<SVGElement> & { isSolid?: boolean };

export const NavSearchIcon = memo(({ isSolid, ...rest }: Props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    {/* active = the same glyph in a bold stroke (a filled disc with a white ring looked like a button) */}
    <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth={isSolid ? 2.6 : 1.5} />
    <path d="M21 21L18.5 18.5" stroke="currentColor" strokeWidth={isSolid ? 2.6 : 1.5} strokeLinecap="round" />
  </svg>
));

export const NavProfileIcon = memo(({ isSolid, ...rest }: Props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <circle cx="12" cy="7.5" r="4.25" stroke="currentColor" strokeWidth="1.5" fill={isSolid ? 'currentColor' : 'none'} />
    <path
      d="M3.75 20.25c0-3.45 3.7-5.75 8.25-5.75s8.25 2.3 8.25 5.75c0 .55-.45 1-1 1H4.75c-.55 0-1-.45-1-1Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
      fill={isSolid ? 'currentColor' : 'none'}
    />
  </svg>
));
